import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoal } from '../context/GoalContext';
import Header from '../components/Header';
import Input from '../components/Input';
import Button from '../components/Button';
import styles from './CreateGoal.module.css';

const templates = ['Emergency fund', 'Vacation', 'New home', 'New car', 'Education'];

const CreateGoalStep1 = () => {
  const navigate = useNavigate();
  const { goal, setGoal } = useGoal();
  const [name, setName] = useState(goal.name || '');

  const handleContinue = () => {
    setGoal(prev => ({ ...prev, name }));
    navigate('/create-goal/step2');
  };

  return (
    <div className={styles.screen}>
      <Header title="New goal" />

      <div className={styles.progress}>
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: '25%' }} />
        </div>
        <span className={styles.progressLabel}>1 of 4</span>
      </div>

      <div className={styles.body}>
        <h2 className={styles.heading}>What are you saving for?</h2>
        <p className={styles.sub}>Give your goal a name that motivates you.</p>

        <Input
          label="Goal name"
          placeholder="e.g. Trip to Japan"
          value={name}
          onChange={(e) => setName(e.target.value)}
          id="goal-name"
        />

        <div className={styles.chips}>
          {templates.map(t => (
            <button
              key={t}
              className={`${styles.chip} ${name === t ? styles.chipActive : ''}`}
              onClick={() => setName(t)}
              type="button"
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.footer}>
        <Button label="Continue" onClick={handleContinue} disabled={name.trim().length === 0} />
      </div>
    </div>
  );
};

export default CreateGoalStep1;
